// extracted by mini-css-extract-plugin
module.exports = {"superElipse":"super-ellipse-skins-medium-superElipse-3e3b2323","strokeWidth":"super-ellipse-skins-medium-strokeWidth-b3df3bc3"};